"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaConfigOnline = exports.yupConfigOnline = void 0;
const yup = __importStar(require("yup"));
const IIniOnlineSGE2_1 = require("../IIniOnlineSGE2");
const configBolerim_1 = require("./configBolerim");
const configDeltaClass_1 = require("./configDeltaClass");
const configEmail_1 = require("./configEmail");
const configMenuOnline_1 = require("./configMenuOnline");
exports.yupConfigOnline = yup.object({
    configuracoes: IIniOnlineSGE2_1.yupConfiguracoes.label('Configurações gerais'),
    menuonline: configMenuOnline_1.yupConfigMenuOnline.label('Configurações dos menus online'),
    boletim: configBolerim_1.yupConfigBoletimOnline.label('Bloqueio de boletins'),
    app: configDeltaClass_1.yupConfigDeltaClass.label('Configurações do DeltaClass'),
    email: configEmail_1.yupConfigEmailSmtp.notRequired().nullable().label('Configurações de e-mail'),
});
exports.schemaConfigOnline = exports.yupConfigOnline.shape({});
